import e from "prop-types";
import o from "styled-components";

function r(e, o, r) {
  return o in e ? Object.defineProperty(e, o, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = r, e;
}

function t(e, o) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    o && (t = t.filter(function (o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, t);
  }

  return r;
}

function n(e) {
  for (var o = 1; o < arguments.length; o++) {
    var n = null != arguments[o] ? arguments[o] : {};
    o % 2 ? t(n, !0).forEach(function (o) {
      r(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : t(n).forEach(function (o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }

  return e;
}

var a = function a(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    i = function i() {
  for (var e = "", o = 0; o < arguments.length; ++o) {
    var r = o < 0 || arguments.length <= o ? void 0 : arguments[o];
    "" !== e && (e += " ");
    var t = a(r);
    "rem" !== t.units ? e += t.number / 16 : e += t.number, 0 != t.number && (e += "rem");
  }

  return e;
},
    c = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    l = n({}, c, {}, {
  textColor: c.charcoal,
  textColorSuccess: c.white,
  textColorInfo: c.white,
  textColorWarning: c.charcoal,
  textColorError: c.white
}),
    s = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    u = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    f = n({}, s, {}, {
  fontColor: l.black,
  fontColorAlt: l.white,
  fontSize: i(16)
}, {
  fontWeights: u,
  fontHeader: s.fontFamily,
  fontBody: s.sans,
  fontWeight: u
}),
    b = n({
  name: "Verizon Theme"
}, l, {}, f, {}, {
  primary: l.black,
  secondary: l.white,
  accent: l.red,
  background: l.white,
  backgroundColorDisabled: l.coolGray3,
  success: l.green,
  info: l.blue,
  warning: l.yellow,
  error: l.orange,
  disabled: l.coolGray3,
  textColorSuccess: l.white,
  textColorInfo: l.white,
  textColorWarning: l.black,
  textColorError: l.black,
  textColorDisabled: l.white,
  borderWidth: i(1),
  borderStyle: "solid",
  borderColor: l.coolGray3,
  border: "".concat(i(1), " solid ").concat(l.coolGray3),
  borderColorDisabled: l.coolGray3,
  linkColor: l.black,
  linkColorHover: l.blue,
  linkColorActive: l.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(i(4), " solid ").concat(l.charcoal),
  hrSecondary: "".concat(i(1), " solid ").concat(l.charcoal),
  hrTertiary: "".concat(i(1), " solid ").concat(l.coolGray3)
}),
    d = 16,
    y = function y(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    h = function h() {
  for (var e = "", o = 0; o < arguments.length; ++o) {
    var r = o < 0 || arguments.length <= o ? void 0 : arguments[o];
    "" !== e && (e += " ");
    var t = y(r);
    "rem" !== t.units ? e += t.number / d : e += t.number, 0 != t.number && (e += "rem");
  }

  return e;
},
    g = {
  type: e.oneOf(["heavy", "light", "xLight", "accent"]),
  theme: e.object,
  inverted: e.bool,
  active: e.bool,
  noMargin: e.bool
},
    m = {
  type: "heavy",
  theme: b,
  inverted: !1,
  active: !1,
  noMargin: !1
},
    p = o.div.withConfig({
  displayName: "Line",
  componentId: "sc-180osn9-0"
})(["height:", ";width:100%;background-color:", ";margin-top:", ";margin-bottom:", ";"], function (e) {
  var o = e.type;
  return h("heavy" === o || "accent" === o ? 4 : 1);
}, function (e) {
  return function (e, o, r, t) {
    var n = t.black;
    "accent" === e || r ? n = t.red : o ? n = t.white : "xLight" === e && (n = t.grayLight);
    return n;
  }(e.type, e.inverted, e.accent, e.theme);
}, function (e) {
  var o = e.noMargin;
  return h(o ? 0 : 24);
}, function (e) {
  var o = e.noMargin;
  return h(o ? 0 : 24);
});

p.propTypes = g, p.defaultProps = m;
export { p as Line };